<template>
  <v-container   class ="mt-16">
    <!-- Appraisee Selection -->
    <v-form ref="form" v-model="isAppraisalFormValid" lazy-validation> 
    <v-row>
      <v-col class="d-flex" cols="12">
        <v-autocomplete
          :items="appraisalusers"
          outlined
          label="Employee"
          v-model="appraisee"
          item-value="appe_EmployeeCode"
          item-text="appe_EmployeeName"
          return-object
          :item-disabled="isItemDisabled"
          :rules="[v => !!v || 'Appraisee is required']"
          @change="onAppraiseeChange"
          :loading="isAppeLoading"
        >
          <template v-slot:item="{ item }">
            <v-list-item-avatar>
              <v-img v-if="item.appr_avathar" :src="item.appr_avathar"></v-img>
              <v-icon v-else>mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content >
              <v-list-item-title >
                {{item.appe_EmployeeName }} {{ item?.self_appraisal ? "(Self)" : ''  }}
              
              </v-list-item-title>
              <v-list-item-subtitle>{{ item.appe_Department }} - {{ item.appe_Designation }}</v-list-item-subtitle>
            </v-list-item-content>
          </template>
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  No Data Available -
                  <span @click="getAppraisees()" style="color: blue; cursor:pointer;">
                    Search on Server
                  </span>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
      
        <v-btn icon @click="getAppraisees">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="showInstructions">
      <v-toolbar color='primary'   dense flat>
        <v-toolbar-title  class="justify-center">
          Instructions for Appraisers
        </v-toolbar-title>
        
        <v-spacer></v-spacer>
        <v-btn icon @click="showInstructions=false"> <v-icon> mdi-close</v-icon></v-btn>

      </v-toolbar>
      <v-card>
        <v-card-title class="justify-center responsive-text">
          Employee Annual Performance Appraisal - {{ new Date().getFullYear() }}
        </v-card-title>
        <v-list class="mx-3" dense>
          <!-- <div class="subheading">Instructions for Appraisers: Employee Annual Performance Appraisal</div> -->
          <div class="body-1 my-3">
            Dear {{ fbuserdata?.firstname }},<br><br>
            As we approach the annual performance appraisal period, it is essential to ensure that each evaluation is conducted with the utmost integrity and professionalism. Your role in this process is crucial to maintaining a fair and motivating environment for all employees. Please adhere to the following guidelines when evaluating your team members:
          </div>
          <v-divider></v-divider>
          <v-list-item-group>
            <v-list-item v-for="(guideline, index) in guidelines" :key="index">
              <v-list-item-content>
                <v-list-item-subtitle>{{ guideline.title }}</v-list-item-subtitle>
                <v-list-item-content v-html="guideline.description"></v-list-item-content>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
          <v-divider></v-divider>
          <div class="body-1 my-3">
            Your commitment to a fair, accurate, and supportive appraisal process is vital. By following these guidelines, we can ensure that each employee receives a meaningful evaluation that recognizes their contributions and guides their development.<br>
            <br>
            Thank you for your diligence and integrity in this important task.<br><br>
            Best regards,<br><br>
            The Management. <br>
            <span v-if="fbuserdata?.company === 'Triton'">Triton Middle East LLC.</span>
            <span v-else-if="fbuserdata?.company === 'Skymat'">Skymat Building Materials Trading LLC.</span>
          </div>
        </v-list>
        <v-row class="">
          <v-col cols="9">
            <div class="caption">
              To view this instructions at any time, please press <span> <v-icon small>
              mdi-information
              </v-icon> or in <v-icon>mdi-dots-vertical</v-icon></span>
            </div>
          </v-col>
          <v-col cols="3">
            <v-btn text class="primary" @click="showInstructions = false">
             Agree
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <!-- memos -->
    <v-dialog v-model="memoDialog" max-width="600px" persistent> 
      <v-card>
        <v-toolbar color ="primary" dark
          dense
          flat
        > 
        <v-toolbar-title>        
          Memo Details          
      </v-toolbar-title>
      <v-spacer></v-spacer>
          <v-btn icon @click="fetchMemos(refresh=true)">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>            
          <v-btn icon @click="memoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-progress-linear v-if="isMemosLoading" color="primary" indeterminate></v-progress-linear>
        <v-card-title>
          {{ appraisee?.appe_EmployeeName}}
        </v-card-title>
        <v-card-subtitle>
          Desg: {{ appraisee?.appe_Designation}} <br>
          Dept: {{ appraisee?.appe_Department}}
        </v-card-subtitle>
        
        <v-card-text>
          <v-container>
            <v-alert 
            v-if="!isMemosLoading && memos.length === 0"
            outlined  
            type="warning"
            prominent
            border="left"
            >  
            <v-row align="center">
              <v-col class="grow">
                No memos available for the selected appraisee.
              </v-col>
              <v-col class="shrink" >
                <v-btn color="warning darken-1" outlined @click="fetchMemos(true)"> Try Fetching Again</v-btn>
              </v-col>
            </v-row>
            </v-alert>
            <v-expansion-panels v-else>
            <v-expansion-panel v-for="memo in memos" :key="memo.MEM_DOCNO">
              <v-expansion-panel-header>
                {{ memo.MEM_SUBJECT }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-subtitle>Memo No: {{ memo.MEM_DOCNO }}</v-card-subtitle>
                <v-card-text>
                  Created by: {{ memo.MEM_CREATED_BY }} on {{ new Date(memo.MEM_CREATED_TS).toLocaleDateString() }}
                  <br>
                  Posted by: {{ memo.MEM_POSTED_BY }} at {{ memo.MEM_ISSUED_AT }}
                  <br>
                  Severity: {{ memo.MMS_SEVERITY_DESC }}
                  <br>
                  Type: {{ memo.MMT_DESC }}
                </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="text-center">
        <v-progress-circular
          color="primary"
          indeterminate
          :size="68"
          :width="6"
          v-if="isQuestionLoading"
        ></v-progress-circular>
    </div>
    <v-alert
      v-if="!appraisee"
      outlined
      type="warning"
      prominent
      border="left"
    >
      Please Select Appraisee
    </v-alert>
  
    <!-- Stepper for Questions -->
    <v-toolbar color="primary" dark dense flat>
    <v-toolbar-title>
      {{ appraisee?.self_appraisal ? "Self Evaluation" : "Appraise Evaluation" }}: {{ questions.length }} Questions
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <template v-if="!$vuetify.breakpoint.xsOnly">
      <!-- Icons visible on tablets and larger screens -->
      <v-btn icon @click="fetchQuestions">
        <v-icon large>mdi-refresh</v-icon>
      </v-btn>
      <v-btn
        color="amber darken-2"        
        @click="showMemos"        
        variant="tonal"  
        :disabled="!appraisee"       
      >
        Show Memos
      </v-btn>
      
      <v-btn icon @click="showInstructions = true">
        <v-icon large>mdi-information</v-icon>
      </v-btn>
    </template>
    <v-menu v-else bottom right>
      <!-- Dropdown menu for extra small screens -->
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="fetchQuestions">
          <v-list-item-icon>
            <v-icon>mdi-refresh</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Refresh</v-list-item-title>
        </v-list-item>
        <v-list-item :disabled="!appraisee" @click="showMemos">
          <v-list-item-icon>
            <v-icon>mdi-note-text</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Show Memos</v-list-item-title>
        </v-list-item>
        <v-list-item @click="showInstructions = true">
          <v-list-item-icon>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Show Instructions</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>    
  </v-toolbar>
  <v-progress-linear 
      v-if = "isQuestionLoading"       
      color="primary"
      indeterminate
    ></v-progress-linear>
    <v-alert
      v-if="questionLengthMismatch && !isQuestionLoading"
      outlined
      type="warning"
      prominent
      border="left"
      :disabled="isQuestionLoading"
    >  
    
    <v-row align="center">
      <v-col class="grow">
        Questions Missing for {{ evaluationType }}, please contact IT.
      </v-col>
      <v-col class="shrink" >
        <v-btn color="warning darken-1" outlined @click="fetchQuestions"> Try Fetching Again</v-btn>
      </v-col>
    </v-row>
    </v-alert>

    <v-stepper v-model="step" v-else-if="questions.length && appraisee">
    <v-stepper-header>            
        <template v-for="(chunk, index) in questionChunks">
        <v-stepper-step
          :key="'step-' + index"
          :step="index + 1"
          :complete="step > index + 1"
        >
          <!-- Step {{ index + 1 }} -->
        </v-stepper-step>

        <!-- Place a divider only if it's not the last item -->
        <v-divider v-if="index < questionChunks.length - 1" :key="'divider-' + index"></v-divider>
      </template>
    </v-stepper-header>
    
    <v-stepper-items >  
          
      <v-stepper-content v-for="(chunk, index) in questionChunks" :key="index" :step="index + 1">
        <v-row>
        <v-col cols="12" v-for="question in chunk" :key="question.id">
          <v-card class="mb-4">
            <v-card-title class="responsive-text">
              {{ question.question }}
            </v-card-title>
            <v-card-subtitle class="responsive-text">
              {{ question?.info }}
            </v-card-subtitle>
            <v-card-text>
              <v-radio-group
              v-model="ratings[question.id]" 
              :column="$vuetify.breakpoint.smAndDown"
              :row="!$vuetify.breakpoint.smAndDown"
              :rules="[(v) => (v !== undefined && v !== null) || 'Please select an option']" 
              required
              >
                <v-radio
                  v-for="option in question.options"
                  :key="option.rating_value"
                  :label="option.option_text"
                  :value="option.rating_value"
                ></v-radio>
              </v-radio-group>
              
              <v-textarea
                v-model="remarks[question.id]"
                :label="question.is_remark_mandatory ? 'Remarks Mandatory' : 'Remarks'"
                rows="1"
                :rules="question.is_remark_mandatory ? [v => !!v || 'Remarks are required'] : []"
                auto-grow
                :required = question.is_remark_mandatory
              ></v-textarea>
            </v-card-text>
          </v-card>
        </v-col>                
      </v-row>
      <v-row>
          <v-col cols="6">
          <v-btn @click="prevStep" :disabled="step === 1">Previous</v-btn>
          </v-col>
          <v-col cols="6" class="text-right">
          <v-btn @click="nextStep">Next</v-btn>
          </v-col>
      </v-row>
      </v-stepper-content>
    </v-stepper-items>
    
    </v-stepper>
    <!-- Progress Bar -->
    <v-progress-linear
          :value="answeredQuestionsPercentage"
          height="10"
          color="primary"
          striped
        ></v-progress-linear>

    <v-card v-if="allQuestionsAnswered && step>stepCount " :disabled="!appraisee ||isQuestionLoading">
      <v-card-title>Summary of Responses
      <v-spacer></v-spacer>
      <v-btn color='primary' icon fab small outlined>
      <v-icon @click="step=1">mdi-pencil</v-icon>
    </v-btn>
    </v-card-title>
      <v-card-text>
        <v-list dense>
          <v-list-item v-for="(question, qIndex) in questions" :key="qIndex">
            <v-list-item-content class="responsive-text">
              {{ qIndex + 1 }}. {{ question.question }}: 
              <strong>{{ getOptionText(question, ratings[question.id]) }}</strong>
              <span v-if="remarks[question.id]" class=" responsive-text font-italic">, Remark: {{ remarks[question.id] }}</span>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-checkbox v-model="isAgreeCheck">
      <template v-slot:label>
        <div class="responsive-text">
          I , {{ fbuserdata?.firstname }} {{ fbuserdata?.lastname }},hereby agree that I am submitting this evaluation without any bias and to the best of my knowledge and established guidelines.  
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <span @click="showInstructions = true" style="color: blue; cursor: pointer;" v-on="on">(Instructions)</span>
          </template>
          <span>Click here to view detailed instructions .</span>
          </v-tooltip>
        </div>
      </template>
    </v-checkbox>
      </v-card-text>
    </v-card>
     
      <!-- Submit Button -->
    <v-row justify="space-around" class="mt-5">
        <v-col cols="4">
            <v-btn @click="submitRatings" color="primary"  block :disabled="!allQuestionsAnswered  || !isAgreeCheck || !appraisee ||isloading" >Submit</v-btn>
        </v-col>
        <v-col cols="4">
          <v-btn color="error" block @click="resetForm">Reset</v-btn>
        </v-col>
        <v-col cols="4">
          <v-btn color="warning" block @click="cancelAppraisee">Cancel</v-btn>
        </v-col>
    </v-row>

    
    </v-form>
  </v-container>
</template>

<script>
import dynamic_axios from "../services/dynamic_axios";


export default {
  data() {
    return {
      appraisee: null,
      questions: [],
      ratings: {},
      remarks: {},
      step: 1,
      isloading : false,
      isAppeLoading : false,
      isAppraisalFormValid: true,
      showInstructions: true,
      guidelines: [
        {
          title: "1. Rate Genuinely with Facts",
          description: `
            <strong>Objective Evaluation:</strong> Ensure your ratings are based on specific, observable behaviors and outcomes. Avoid generalizations and focus on concrete examples of performance.<br>
            <strong>Data-Driven:</strong> Utilize metrics, performance data, and documented achievements or areas for improvement to support your ratings.`
        },
        {
          title: "2. Avoid Personal Bias",
          description: `
            <strong>Impartiality:</strong> Personal feelings towards an employee, whether positive or negative, should not influence your appraisal. Base your evaluation solely on professional performance.<br>
            <strong>Diverse Perspective:</strong> Consider seeking input from other colleagues or team members who have worked closely with the employee to provide a well-rounded view.`
        },
        {
          title: "3. Evaluate Within the Spirit of the Process",
          description: `
            <strong>Consistency:</strong> Ensure your evaluations align with the company's performance standards and appraisal guidelines.<br>
            <strong>Development Focus:</strong> Highlight areas of strength and provide constructive feedback on areas needing improvement, aiming to support the employee's professional growth.`
        },
        {
          title: "4. No Random Selection of Options",
          description: `
            <strong>Deliberate Choices:</strong> Avoid arbitrary selection of ratings. Each rating should reflect a thoughtful assessment of the employee’s performance.<br>
            <strong>Scale Understanding:</strong> Familiarize yourself with the rating scale and criteria to ensure accurate and consistent evaluations.`
        },
        {
          title: "5. Justify Your Ratings",
          description: `
            <strong>Detailed Comments:</strong> Provide clear and specific reasons for each rating. This includes citing examples and providing context where necessary.<br>
            <strong>Balanced Feedback:</strong> Ensure your justification includes both positive feedback and areas for development. This balanced approach helps employees understand their performance comprehensively.`
        }
      ],
      memos: [],
      memoDialog :false,
      isMemosLoading: false,
      isQuestionLoading: false,
      isAgreeCheck:false,
      expectedSelfQuestions: 10,
      expectedAppraiseQuestions: 25,
    };
  },
  computed: {
      user() {
          return this.$store.getters.factsuser;
      },
      userProfile() {
          return this.$store.getters.userProfile;
      },
      fbuserdata(){
          return this.$store.getters.fbuserdata;
      },
      perferedAPI() {
          return this.$store.getters.perferedAPI;
      },
      appraisalusers() {
          return this.$store.getters.myAppraisees;
      },
      questionChunks() {
          const chunkSize = 5;
          return this.questions.reduce((chunks, question, index) => {
              const chunkIndex = Math.floor(index / chunkSize);
              if (!chunks[chunkIndex]) {
              chunks[chunkIndex] = [];
              }
              chunks[chunkIndex].push(question);
              return chunks;
          }, []);
      },
      stepCount() {
          return this.questionChunks.length;
      },
      answeredQuestionsPercentage() {
        const totalQuestions = this.questions.length;
        let answeredCount = 0;

        this.questions.forEach(question => {
          const isRatingProvided = this.ratings[question.id] !== undefined;
          const isRemarkProvided = !question.is_remark_mandatory || this.remarks[question.id];
          
          if (isRatingProvided && isRemarkProvided) {
            answeredCount++;
          }
        });

        return (answeredCount / totalQuestions) * 100;
      },
      allQuestionsAnswered() {
        return this.questions.every(question => {
            return (
            this.ratings[question.id] !== undefined &&
            (!question.is_remark_mandatory || this.remarks[question.id])
            );
        });
      },
      questionLengthMismatch() {
        if (this.appraisee) {
          const expectedLength = this.appraisee.self_appraisal ? this.expectedSelfQuestions : this.expectedAppraiseQuestions;
          return this.questions?.length !== expectedLength;
        }
        return false;
      },
      evaluationType() {
        return this.appraisee?.self_appraisal ? "Self Evaluation" : "Appraise Evaluation";
      },
  },

methods: {
    async getAppraisees() {
      this.isAppeLoading=true
      try {
        const result = await this.$store.dispatch("getAllApprUsers");
        console.log(result); // Success log
        // this.$toast.success("Appraisees loaded successfully!");
      } catch (error) {
        // console.error(error); // Log error for debugging
        this.$toast.error("Error loading appraisees: " + error);
      } finally {
        this.isAppeLoading = false; // Ensure loading state is cleared
      }
      // const result = await this.$store.dispatch("getAllApprUsers");
      // console.log(result)
      // if(result) this.isAppeLoading=false
      // else this.$toast.error(result)
    },
    
    getOptionText(question, ratingValue) {
      const option = question.options.find(opt => opt.rating_value === ratingValue);
      return option ? option.option_text : 'No option selected';
    },
    async fetchQuestions() {
      if (!this.appraisee) return 'Appraise not selected'
      this.isQuestionLoading=true
      // console.log(this.appraisee)
      // console.log(JSON.stringify(this.appraisee))
      this.isloading = true;
      const company =  this.appraisee?.appe_Company;
      const apq_type = this.appraisee?.self_appraisal ? 'SELF': 'APPE';
      const apq_dept_id =  this.appraisee?.appe_dept_id;
      const apq_desg_id =  this.appraisee?.appe_desg_id;
      // const designation = this.appraisee?.appe_Designation;
      // const department =  this.appraisee?.appe_Department;
      const params = {
        apq_type,
        apq_dept_id,
        apq_desg_id,
        // designation,
        // department,
      }
      try {
          const response = await dynamic_axios.get("/appraisal/appraisalQuestions",
          { 
            params,
            apiName: company 
          });
          this.questions = response.data;
      } catch (error) {
          console.error("Failed to fetch questions", error);
          this.$toast.error("Failed to fetch questions", error)
      } finally{
        this.isloading = false;
        this.isQuestionLoading = false;
      }
    },
    showMemos(){
      this.memoDialog = true
      this.fetchMemos();
    },
    async fetchMemos(refresh=false) {

      
      if(!refresh && this.memos.length) return  

      this.isMemosLoading = true;
      if (!this.appraisee) return  this.$toast.warning('Appraise not selected')
      
      const company =  this.appraisee?.appe_Company;
      const appraiseeCode = this.appraisee?.appe_EmployeeCode;
      const params = {
        appraiseeCode
      }

      try {
          const response = await dynamic_axios.get("/appraisal/memodetails",
          { 
            params,
            apiName: company 
          });
          this.memos = response.data;
          // console.log("this.memos",this.memos)
      } catch (error) {
          console.error("Failed to fetch questions", error);
      } finally{
        this.isMemosLoading = false;
      }
    },
    nextStep() {
      if (this.validateCurrentStep()) {
          this.step++;
      }else{        
        this.$toast.warning(`complete this step ${this.step}`)
        this.$refs.form.validate()
      }        
    },
    prevStep() {
      this.step--;
    },
    validateCurrentStep() {
      const currentChunk = this.questionChunks[this.step - 1];
      return currentChunk.every(question => {
          return (
          this.ratings[question.id] !== undefined &&
          (!question.is_remark_mandatory || this.remarks[question.id])
          );
      });
    },
    async submitRatings() {
        try {
            const result = await this.$swal({
                title: 'Are you sure?',
                text: 'Once submitted, you will not be able to edit this score!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, submit it!'
            });

            if (result.isConfirmed) {
                this.$store. commit("setLoading", true);
                let appraisal_score = {
                    appraiserCompany: this.fbuserdata?.company,
                    appraiserCode: this.user?.USER_EMP_DOCNO || this.userProfile?.EMPMST_DOCNO,
                    appraiseeCompany: this.appraisee?.appe_Company,
                    appraiseeCode: this.appraisee?.appe_EmployeeCode,
                    evaluatedBy: this.user?.USER_LOGINID,
                    scores: this.questions.map(question => ({
                        questionId: question.id,
                        score: this.ratings[question.id],
                        maxScore: question.options ? Math.max(...question.options.map(option => option.rating_value)) : 5,
                        minScore: question.options ? Math.min(...question.options.map(option => option.rating_value)) : 1,
                        remark: this.remarks[question.id] || ''
                    })),
                    is_self: this.appraisee?.self_appraisal ? 'SELF' : 'APPE',
                    appe_id: this.appraisee?.appe_id
                  };

                const company = this.appraisee?.appe_Company;
                const response = await dynamic_axios.post("/appraisal/appraisal_score", appraisal_score, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    apiName: company
                });

                this.$toast.success(`Ratings for ${this.appraisee?.appe_EmployeeCode} submitted successfully: ${response.data.message}`);
                this.getAppraisees();
                this.cancelAppraisee();
                this.$store. commit("setLoading", false);
            }
        } catch (error) {
            console.error("Failed to submit ratings", error);
            this.$store. commit("setLoading", false);
            // Use `error.response` if available, otherwise fallback to `error.message`
            this.$toast.error(`Failed to submit ratings: ${error.response?.data?.message || error.message}`);
        }
    },
    isItemDisabled(item) {
      return !!item.appe_PostedBy;
    },
    async onAppraiseeChange() {
      this.questions = [];
      this.memos = [];
      if (!this.appraisee) {
        this.$toast.error("Appraisee is required");
        return;
      }
      // Reset form values
     this.resetForm();
      // Fetch new questions
      await this.fetchQuestions();
    },
    resetForm(){
      this.ratings = {};
      this.remarks = {};
      this.step = 1;
      this.isAgreeCheck=false;
      
    },
    cancelAppraisee(){
      this.questions = [];
      this.memos = [];
      this.appraisee =null
      this.resetForm();
    },
    get_profile(){
      this.$store.dispatch("get_employee", { employ_id: this.user?.USER_EMP_DOCNO })
    },
  },
  mounted(){
    this.getAppraisees()
  },
};
</script>

<style scoped>
.mb-4 {
margin-bottom: 1rem;
}

.responsive-text {
  word-break: keep-all;
  white-space: normal; /* Ensures text wraps only at whole words */
  overflow-wrap: normal;  /* Breaks long words if necessary */
}

@media (max-width: 600px) { /* Adjust breakpoint as needed */
  .responsive-text {
    font-size: 1.000rem; /* Smaller font size for small screens */
  }
}
</style>

